<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Данные гостей при регистрации

  .container.mt-5
    .white_block
      .row 
        .col-sm-10 В этом разделе представлены данные, которые указывают гости при получании карты.
          br
          | Могут присутствовать дубликаты строк, если гость заполнял форму для получения карты несколько раз.
        .col-sm-2(style="text-align: right")
          <download-csv :data="raw_rows" :disabled="loading">
            button.styled(:disabled="loading")
              i.fas.fa-cloud-download-alt
              |
              | CSV
          </download-csv>

    div
      .row
        .col
          div(
            v-for="s of selections",
            :class="{ selection: true, selected: s.key == selected_group }",
            @click="selected_group = s.key"
          )
            i(:class="s.icon")
            .name {{ s.name }}
            span.amount {{ group_rows[s.key].length }}

    .white_block(style="padding: 0")
      .row
        .col-sm(v-if="loading")
          .loader_holder(style="margin: 0 auto; width: 200px")
            object(type="image/svg+xml", data="/assets/loaders/infinity.svg")
        .col-sm(v-if="!loading")
          //- <vue-table-dynamic :params="params" width="100%"></vue-table-dynamic>
          vue-good-table(
            :columns="columns",
            :rows="group_rows[selected_group]",
            :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Поиск по гостям' }",
            :pagination-options="{ enabled: true, perPage: 50, nextLabel: 'Дальше', prevLabel: 'Назад', ofLabel: 'из', pageLabel: 'страница', allLabel: 'Всё', rowsPerPageLabel: 'Строк на странице' }",
            styleClass="datatable vgt-table condensed"
          )
</template>
<script>
// https://xaksis.github.io/vue-good-table/guide/configuration/column-options.html#hidden
const validateEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email.toLowerCase());
};

import { Tooltip } from "element-ui";
import moment from "moment";
import apiDriver from "../../apiDriver";
import JsonCSV from "vue-json-csv";

export default {
  components: {
    [Tooltip.name]: Tooltip,
    "download-csv": JsonCSV,
  },

  data() {
    return {
      loading: true,
      selected_group: "all",
      selections: [
        {
          key: "all",
          name: "Все",
          icon: "fas fa-users",
        },
        {
          key: "no_duplicates",
          name: "Без дубликатов",
          icon: "fas fa-clone",
        },
        {
          key: "bd_today",
          name: "Сегодня День Рождения",
          icon: "fas fa-birthday-cake",
        },
        {
          key: "bd_in_7_days",
          name: "День Рождения в ближайшие 7 дней",
          icon: "fal fa-birthday-cake",
        },
        {
          key: "warnings",
          name: "Ошибки в данных",
          icon: "fas fa-crosshairs",
        },
      ],
      columns: [
        {
          label: "Создан",
          field: "createdAt",
          type: "date",
          dateInputFormat: "dd.MM.yyyy HH:mm",
          dateOutputFormat: "dd.MM.yyyy HH:mm",
          width: "150px",
        },
        {
          label: "Телефон",
          field: "phone",
        },
        {
          label: "ID",
          field: "id",
          type: "number",
          hidden: true,
        },
        {
          label: "Имя",
          field: "firstname",
        },
        {
          label: "Фамилия",
          field: "lastname",
        },
        {
          label: "Email",
          field: "email",
          sortable: false,
        },
        {
          label: "Пол",
          field: "gender",
          filterOptions: {
            enabled: true,
            filterDropdownItems: ["М", "Ж", "-"],
            placeholder: "Пол",
          },
          width: "100px",
        },
        {
          label: "ДР",
          field: "hb",
          type: "date",
          dateInputFormat: "yyyy-MM-dd",
          dateOutputFormat: "dd.MM.yyyy",
        },
        {
          label: "Источник",
          field: "source",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [],
            placeholder: "Источник",
          },
          width: "140px",
        },
        {
          label: "utm_source",
          field: "utm_source",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [],
            placeholder: "utm_source",
          },
        },
        {
          label: "utm_campaign",
          field: "utm_campaign",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [],
            placeholder: "utm_campaign",
          },
        },
        {
          label: "utm_content",
          field: "utm_content",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [],
            placeholder: "utm_content",
          },
        },
      ],
      rows: [],
      group_rows: {
        all: [],
        bd_today: [],
        bd_in_7_days: [],
        warnings: [],
        no_duplicates: [],
      },
      raw_rows: [],
    };
  },

  computed: {},

  mounted() {
    this.getClients();
  },

  methods: {
    sourceName(sn) {
      let names = {
        search: "Из поиска",
        local: "Проходил мимо",
        old_place: "Давно знает",
        friends: "От друзей",
        instagram: "Из Instagram",
        maps: "На картах",
        vk: "Из ВК",
        random: "Случайно",
        "search-yandex": "Поиск Yandex.ru",
        "search-google": "Поиск Google.com",
        "search-mail": "Поиск Mail.ru",
        facebook: "Facebook",
        "maps-yandex": "Карты Яндекс",
        "maps-google": "Карты Google",
        "maps-2gis": "Карты 2GIS",
        "street-adv": "Реклама на улице",
        oldmember: "Постоянник",
        "": "Не указано",
      };
      return names[sn] ? names[sn] : sn;
    },
    async getClients() {
      let users = (
        await apiDriver.services.api.get("cards", "wallet/getClients")
      ).data;
      console.log(users.clients);
      let sources = [];
      let utm_sources = [];
      let utm_campaigns = [];
      let utm_contents = [];
      for (let c of users.clients) {
        let d = {
          id: parseInt(c.id),
          firstname: c.firstname || "",
          lastname: c.lastname || "",
          phone: c.phone,
          email: c.email,
          gender: c.gender == 2 ? "Ж" : c.gender == 1 ? "М" : "-",
          hb: c.hb
            ? c.hb == "Invalid date"
              ? "1970-01-01"
              : c.hb
            : "1970-01-01",
          source: this.sourceName(c.source),
          utm_source: c.utm_source,
          utm_campaign: c.utm_campaign,
          utm_content: c.utm_content,
          createdAt: moment(c.createdAt).format("DD.MM.YYYY HH:mm"),
        };
        if (!utm_sources.includes(d.utm_source) && d.utm_source)
          utm_sources.push(d.utm_source);
        if (!utm_campaigns.includes(d.utm_campaign) && d.utm_campaign)
          utm_campaigns.push(d.utm_campaign);
        if (!utm_contents.includes(d.utm_content) && d.utm_content)
          utm_contents.push(d.utm_content);
        if (!sources.includes(d.source) && d.source) sources.push(d.source);

        this.group_rows.all.push(d);
        if (
          moment(d.hb, "YYYY-MM-DD").format("MM-DD") ==
            moment().format("MM-DD") &&
          !this.group_rows.bd_today.find((x) => x.phone == d.phone)
        ) {
          this.group_rows.bd_today.push(d);
        }
        if (
          moment(d.hb, "YYYY-MM-DD").year(moment().year()) >= moment() &&
          moment(d.hb, "YYYY-MM-DD").year(moment().year()) <=
            moment().add(7, "days") &&
          !this.group_rows.bd_in_7_days.find((x) => x.phone == d.phone)
        ) {
          this.group_rows.bd_in_7_days.push(d);
        }
        if (!this.group_rows.no_duplicates.find((x) => x.phone == d.phone)) {
          this.group_rows.no_duplicates.push(d);
        }
        if (
          d.gender == "-" ||
          d.firstname.replace(/\s/g, "").length <= 1 ||
          d.lastname.replace(/\s/g, "").length <= 1 ||
          moment(d.hb, "YYYY-MM-DD").year() <
            moment().add(-100, "years").year() ||
          d.hb == "01-01-1970" ||
          d.phone.includes("9999999999") ||
          !validateEmail(d.email) ||
          /[\d\_\)\*\(\&\^\%\$\#\@\!\+\;\:\'\"\№]/.test(d.firstname) ||
          /[\d\_\)\*\(\&\^\%\$\#\@\!\+\;\:\'\"\№]/.test(d.lastname)
        ) {
          this.group_rows.warnings.push(d);
        }
      }
      console.log(sources, utm_sources);
      this.columns.find(
        (x) => x.field == "source"
      ).filterOptions.filterDropdownItems = sources;
      this.columns.find(
        (x) => x.field == "utm_source"
      ).filterOptions.filterDropdownItems = utm_sources;
      this.columns.find(
        (x) => x.field == "utm_campaign"
      ).filterOptions.filterDropdownItems = utm_campaigns;
      this.columns.find(
        (x) => x.field == "utm_content"
      ).filterOptions.filterDropdownItems = utm_contents;
      for (let c of this.columns) {
        if (c.filterOptions) {
          if (c.filterOptions.filterDropdownItems) {
            if (c.filterOptions.filterDropdownItems.length == 0) {
              delete c.filterOptions;
              c.hidden = true;
            }
          }
        }
      }
      this.raw_rows = users.clients;
      this.loading = false;
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.design {
  background: white;
}

.inputModule {
  margin-bottom: 10px;
}

.page-item, .pagination-size {
  border: none;
}

.page-item i.iconfont {
  font-size: 11px;
  height: 12px;
  width: 12px;
  font-weight: 500;
  top: -2px;
  position: relative;
}

.vgt-table td {
  padding: 0 !important;
}

.selection {
  display: inline-block;
  margin: 5px;
  border: 1px solid;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  border-color: #e4e4e4;
  background: white;

  .name {
    display: inline-block;
    margin-left: 5px;
    cursor: pointer;
  }

  .amount {
    background: #eee;
    padding: 3px 6px;
    font-size: 7pt;
    margin-left: 5px;
    border-radius: 5px;
    position: relative;
    top: -2px;
  }

  &:hover {
    border-color: #989898;
  }

  &.selected {
    background: #6c68cb;
    color: white;
    border-color: #48449e;

    .amount {
      background: #48439e;
    }
  }
}

@media (prefers-color-scheme: dark) {
  .selection {
    border-color: #6a6a6a;
    background: #505050;

    .amount {
      background: #2e2e2e;
    }

    &:hover {
      border-color: #989898;
    }

    &.selected {
      background: #6c68cb;
      color: white;
      border-color: #48449e;

      .amount {
        background: #48439e;
      }
    }
  }
}
</style>
